function check_valid() {
    $("form.shopify-product-form #customily-options .swatch-container").each(
        function () {
            var $checked = $(this).find('input[type="radio"]:checked');
            if ($checked.length) {
                $(this)
                    .closest(".customily_option")
                    .removeClass("customily-required-error");
                $(this)
                    .closest(".customily_option")
                    .find(".customily-required-label span")
                    .hide();
            } else {
                $(this)
                    .closest(".customily_option")
                    .addClass("customily-required-error");
                $(this)
                    .closest(".customily_option")
                    .find(".customily-required-label span")
                    .show();
            }
        }
    );

    $("form.shopify-product-form #customily-options select").each(function () {
        if ($(this).val()) {
            $(this)
                .closest(".customily_option")
                .removeClass("customily-required-error");
            $(this)
                .closest(".customily_option")
                .find(".customily-required-label span")
                .hide();
        } else {
            $(this).closest(".customily_option").addClass("customily-required-error");
            $(this)
                .closest(".customily_option")
                .find(".customily-required-label span")
                .show();
        }
    });

    $('form.shopify-product-form #customily-options input[type="text"]').each(
        function () {
            if ($(this).val().length) {
                $(this)
                    .closest(".customily_option")
                    .removeClass("customily-required-error");
                $(this)
                    .closest(".customily_option")
                    .find(".customily-required-label span")
                    .hide();
            } else {
                $(this)
                    .closest(".customily_option")
                    .addClass("customily-required-error");
                $(this)
                    .closest(".customily_option")
                    .find(".customily-required-label span")
                    .show();
            }
        }
    );

    $("form.shopify-product-form #customily-options .customily-file-input").each(
        function () {
            var $checked = $(this).find(".cl_remove-image").is(":visible");
            if ($checked) {
                $(this)
                    .closest(".customily_option")
                    .removeClass("customily-required-error");
                $(this)
                    .closest(".customily_option")
                    .find(".customily-required-label span")
                    .hide();
            } else {
                $(this)
                    .closest(".customily_option")
                    .addClass("customily-required-error");
                $(this)
                    .closest(".customily_option")
                    .find(".customily-required-label span")
                    .show();
            }
        }
    );
    const errorFields = $('.customily_option.customily-required-error:visible');
    if (errorFields.length > 0) {
        $('html, body').animate({
            scrollTop: errorFields.eq(0).offset().top - 120
        }, 300);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // $(document).ready(function(){

        $(".preview_btn,.icon-preview-btn").click(function(e){
            e.preventDefault();
            check_valid();
            if($(".customily_option:visible").hasClass("customily-required-error") == false){

                $('.priview-image-section').show();
                //详情数量赋值到预览上
                $(".pre_quantity").val($(".pre_quantity_par").val());
                var canvas = document.getElementById("preview-canvas");
                var dataURL = canvas.toDataURL('image/png');
                $('.main_priview_img img').attr('src',dataURL);
                $('.smile-launcher-frame-container').hide();
                $('#chat-widget-container').hide();
            }else{
                $(".customily-required-error input").first().focus();
                $(".customily-required-error select").first().focus();
            }
        })


        $(document).click(function (e) {
            if ($('.priview-image-section').is(':visible') && $(e.target).is('.preview_btn') === false && $(e.target).is('#preview-img') === false && $(e.target).is('.main_priview_img') === false  && $(e.target).is('.add_to_cart') === false && $(e.target).is('.popup_action') === false) {
                //点击赋值到详情的数量
                if($(".pre_quantity").val() != $(".quantity").val() || $(e.target).is('.icon-minus') || $(e.target).is('.pre_quantity') || $(e.target).is('.js-change-quantity')){
                    $(".quantity").val($(".pre_quantity").val());
                }else{

                    $('.priview-image-section').hide();
                    $('.smile-launcher-frame-container').show();
                    $('#chat-widget-container').show();
                }
            }
        });

        $(document).on('click','.priview_close_button',function(e){
            e.preventDefault();
            $('.priview-image-section').hide();
            $('.smile-launcher-frame-container').show();
            $('#chat-widget-container').show();
        });

        $(document).on('click','#customily-buy-it-now-btn-preview',function(e){
            e.preventDefault();
            $('.purchase-details__buttons').append('<input type="hidden" name="return_to" value="/checkout" />');
            $(this).addClass('running');
            $('#buy-it-now-btn').addClass('running');
            $(".new-add-to-cart-btn").addClass("from-buyitnow");
            $("#customily-cart-btn").click();

            if($('.preview_btn').hasClass('preview-show-left')){
                $('html, body').animate({
                    scrollTop: $("#customily-cart-btn").offset().top-500
                }, 500);
            }

        });
        $(document).on('click','#customily-add-to-cart-btn-preview',function(e){
            e.preventDefault();
            $("#customily-cart-btn").addClass("from-add-to-cart-preview");
            $("#customily-cart-btn").click();
            if($('.preview_btn').hasClass('preview-show-left')){
                $('html, body').animate({
                    scrollTop: $("#customily-cart-btn").offset().top-500
                }, 500);
            }
        });

        $(document).on('click','#buy-it-now-btn',function(e){
            check_valid();
            if($(".customily_option:visible").hasClass("customily-required-error") == false){
                $('.purchase-details__buttons').append('<input type="hidden" name="return_to" value="/checkout" />');
                $(this).addClass('running');
                $(".new-add-to-cart-btn").addClass("from-buyitnow");
                $(".new-add-to-cart-btn:visible").click();
            }else{
                $(".customily-required-error input").first().focus();
                $(".customily-required-error select").first().focus();
            }
        });
    // });
});

$( window).on("load", function() {
    if($("#custom_product:not([style*='display: none;'])").length){
        const timerRemoveLoadingPreview = setInterval(function(){

            if( $("#customily-cart-btn:not(.running)").length ){

                $(".preview_btn").addClass("ld-done");
                clearInterval(timerRemoveLoadingPreview)
            }
        },200)
    }
});


// 购物车预览图
document.addEventListener('DOMContentLoaded', () => {

    $(".review_design--trigger").each(function (){
        $(this).click(function (){
            let url= $(this).attr("data-src");

            $("#cus-preview-img").attr("src",url);
            $(".cus__modal__preview").addClass("open");

        });

    });

    $(".cus__modal__preview,.cus-close").click(function (){
        $("#cus-preview-img").attr("src","");
        $(".cus__modal__preview").removeClass("open");
    });

    // 阻止冒泡事件
    $("#cus-preview-img").click(function (e) {
        e.stopPropagation();
    });

});

// 设定一个函数来检查div是否在视窗中
function checkDivInViewport() {
    const div = document.getElementById('preview_btn_set');
    const phone_preview = document.querySelector(".preview_phone_btn_fixed");
    try {
        if (div) {
            const rect = div.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                phone_preview.style.display = 'none';
            } else {
                phone_preview.style.display = 'block';
            }
        } else {
            phone_preview.style.display = 'block';
        }
    } catch (error) {
        console.log(error,'fn checkDivInViewport')
    }
    
}
// 添加滚动事件监听器
window.addEventListener('scroll', checkDivInViewport);

// 初始时检查一次
checkDivInViewport();
